/* ERGONOZ — product page enhancements:
 *  (1) move the breadcrumb up under the header, left-aligned to the page gutter.
 *  (2) show the product video as the first, full-width tile at the top of the media
 *      gallery (spanning both gallery columns), autoplaying muted + looped with native
 *      controls; hide the theme's own video tiles so it isn't duplicated. Keeping it
 *      inside the gallery means it doesn't push the details column (buy area) down. */
(function () {
  'use strict';

  function drive(v) {
    if (!v) return;
    v.muted = true; v.setAttribute('muted', '');
    v.loop = true; v.setAttribute('loop', '');
    v.playsInline = true; v.setAttribute('playsinline', '');
    v.controls = true;
    function visible() { var r = v.getBoundingClientRect(); return r.width > 10 && r.height > 10; }
    function play() { if (visible() && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    var n = 0, iv = setInterval(function () { n++; play(); if (n > 16) clearInterval(iv); }, 500);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) play(); }); }, { threshold: 0.25 }).observe(v);
    }
    play();
  }

  function sourceFrom(dm) {
    var v = dm.querySelector('video');
    if (v) {
      var s = v.querySelector('source');
      return { src: (s && s.getAttribute('src')) || v.getAttribute('src') || v.currentSrc || '', poster: v.getAttribute('poster') || '' };
    }
    var tpl = dm.querySelector('template');
    if (tpl) {
      var html = tpl.innerHTML;
      var m = html.match(/<source[^>]+src=["']([^"']+)["']/) || html.match(/<video[^>]+src=["']([^"']+)["']/);
      var pm = html.match(/poster=["']([^"']+)["']/);
      return { src: m ? m[1] : '', poster: pm ? pm[1] : '' };
    }
    return { src: '', poster: '' };
  }

  function relocateBreadcrumb(sec) {
    var nav = document.querySelector('nav[aria-label="breadcrumb"]');
    if (!nav || document.querySelector('.egn-top-breadcrumb')) return;
    var bc = document.createElement('div');
    bc.className = 'egn-top-breadcrumb section section--page-width';
    bc.appendChild(nav);
    sec.parentNode.insertBefore(bc, sec);
  }

  function buildVideo(gallery) {
    if (gallery.querySelector('.egn-gallery-video')) return;
    var dm = gallery.querySelector('deferred-media');
    if (!dm) return;
    var info = sourceFrom(dm);
    if (!info.src) return;
    var grid = gallery.querySelector('.media-gallery__grid') || gallery;
    var isList = grid.firstElementChild && grid.firstElementChild.tagName === 'LI';
    var tile = document.createElement(isList ? 'li' : 'div');
    tile.className = 'egn-gallery-video';
    var v = document.createElement('video');
    v.src = info.src;
    if (info.poster) v.poster = info.poster;
    tile.appendChild(v);
    grid.insertBefore(tile, grid.firstChild);
    // mobile (<750px): the theme hides .media-gallery__grid entirely and shows a slideshow
    // instead, so the injected grid tile never appears there — add a standalone player
    // above the gallery, shown only on small screens via .egn-mobile-video CSS.
    if (!gallery.querySelector('.egn-mobile-video')) {
      var mob = document.createElement('div');
      mob.className = 'egn-mobile-video';
      var mv = document.createElement('video');
      mv.src = info.src;
      if (info.poster) mv.poster = info.poster;
      mob.appendChild(mv);
      gallery.insertBefore(mob, gallery.firstChild);
      drive(mv);
    }
    // hide the theme's own video tiles (grid + mobile slideshow + zoom dialog)
    gallery.querySelectorAll('deferred-media').forEach(function (d) {
      var c = d.closest('.product-media-container') || d.closest('li');
      if (c && c !== tile) c.style.display = 'none';
    });
    drive(v);
  }

  function enhance() {
    var gallery = document.querySelector('.product-information__media');
    if (!gallery) return;
    var sec = gallery.closest('.shopify-section') || gallery.closest('section') || gallery.parentElement;
    relocateBreadcrumb(sec);
    buildVideo(gallery);
  }

  function start() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('deferred-media').then(function () { setTimeout(enhance, 150); });
    }
    setTimeout(enhance, 800);
    setTimeout(enhance, 1500);
    setTimeout(enhance, 3000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* On /th pages, send links to www.ergonoz.com to its Thai locale (/th/...). Menu link URLs
   are not translatable in Shopify, so the Thai shop otherwise sent visitors to the English site. */
(function () {
  if (!/^\/th(\/|$)/.test(location.pathname)) return;
  function localize() {
    var links = document.querySelectorAll('a[href^="https://www.ergonoz.com"], a[href^="https://ergonoz.com"]');
    for (var i = 0; i < links.length; i++) {
      var u;
      try { u = new URL(links[i].href); } catch (e) { continue; }
      if (/^\/th(\/|$)/.test(u.pathname)) continue;
      u.pathname = '/th' + (u.pathname === '/' ? '' : u.pathname);
      links[i].href = u.toString();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', localize);
  else localize();
  setTimeout(localize, 1500);
})();
